import { useState } from 'react'
import type { JSX } from 'react'

import clsx from 'clsx'

import { Button } from '@buffer-mono/popcorn'

import type { CustomLink } from '~publish/legacy/profile-sidebar/types'

import styles from './index.module.css'

export interface LinkPreviewProps {
  isOver: boolean
  bgColor: string
  textColor: string
  item: CustomLink
  setEditingLinkId: (id: string | null) => void
  onDeleteCustomLink: (customLinkId: string) => void
  hasWriteAccess: boolean
}

const LinkPreview = ({
  isOver,
  bgColor,
  textColor,
  item,
  setEditingLinkId,
  onDeleteCustomLink,
  hasWriteAccess,
}: LinkPreviewProps): JSX.Element => {
  const [isConfirmingDelete, setConfirmingDelete] = useState<boolean>(false)

  return (
    <div
      className={clsx(
        styles.previewWrapper,

        {
          [styles.isTarget]: isOver,
          [styles.hasWriteAccess]: hasWriteAccess,
        },
      )}
    >
      <div className={styles.linkPreviewRow}>
        <div
          className={styles.linkPreviewButton}
          style={{ backgroundColor: bgColor, color: textColor }}
          translate="no"
        >
          {item.text}
        </div>
        <div className={styles.linkPreviewRow}>
          <div className={styles.urlWrapper} translate="no">
            {item.url}
          </div>
        </div>
        {hasWriteAccess && (
          <div className={styles.actionsRow}>
            {onDeleteCustomLink && (
              <>
                <Button
                  variant="tertiary"
                  onClick={(): void => setConfirmingDelete(!isConfirmingDelete)}
                >
                  {isConfirmingDelete ? 'Cancel' : 'Delete'}
                </Button>
                {isConfirmingDelete && (
                  <Button onClick={(): void => onDeleteCustomLink(item.id)}>
                    Delete
                  </Button>
                )}
              </>
            )}
            {!isConfirmingDelete && (
              <Button
                variant="secondary"
                onClick={(): void => setEditingLinkId(item.id)}
              >
                Edit
              </Button>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default LinkPreview
